var lib_core = require("lib-core");

var ToolbarModeModel = function () {
    lib_core.Model.apply(this);

    this.tools = this.set("tools", true);
};
lib_core.inherit(ToolbarModeModel, lib_core.Model);
lib_core.JsonParser.registerClass(ToolbarModeModel, "ToolbarModeModel");

module.exports = ToolbarModeModel;

ToolbarModeModel.prototype.registerTool = function (tool) {
    this.tools.add(tool);
};
